import React from "react";
import { Alert } from "antd";
import { withRouter } from "../../../../../utils/helper";
import { DescriptionText, ScreenHeader } from "../../../../../CommonComponents";
import ChantSpinner from "../../../../../CommonComponents/ChantSpinner/ChantSpinner";

import useCreateTicket from "./useCreateTicket";
import EventDetailsSection from "./EventDetailsSection";
import TicketItemsSection from "./TicketItemsSection";
import SubmitSection from "./SubmitSection";

import "./CreateTicket.css";

const CreateTicket = (props) => {
  const form = useCreateTicket(props);

  const {
    editMode,
    loadingDocument,
    loadingMatches,
    isLoading,
    errorInForm,
    handleErrorMessageClose,
  } = form;

  return (
    <div style={{ padding: "12px" }}>
      <ScreenHeader
        title={editMode ? "Edit Group Ticket" : "Create Group Ticket"}
      />
      <DescriptionText showBackground>
        Create group tickets by selecting a ticket type and match (if
        applicable). Generate the ticket 'items' (away match + bus, food +
        drink, etc) including quantity, price. Tickets can be generated with a
        scannable QR code (except away match tickets). Note in the event
        description how tickets are to be distributed. See Help: Tickets for
        more info.
      </DescriptionText>
      <div
        className="ct-form"
        style={{
          marginTop: "var(--screen-general-margin)",
          backgroundColor: "#ffffff",
        }}
      >
        {loadingDocument || loadingMatches || isLoading ? (
          <ChantSpinner isScreenLoader />
        ) : (
          <div>
            {errorInForm.isError && errorInForm.visible && (
              <div className="mb-2">
                <Alert
                  message="Error"
                  description={errorInForm.message}
                  type="error"
                  closable
                  afterClose={handleErrorMessageClose}
                />
              </div>
            )}

            <EventDetailsSection
              type={form.type}
              checkMatchRequired={form.checkMatchRequired}
              matchId={form.matchId}
              matchList={form.matchList}
              loadingMatches={form.loadingMatches}
              editMode={form.editMode}
              quantity={form.quantity}
              remainingTickets={form.remainingTickets}
              eventName={form.eventName}
              section={form.section}
              location={form.location}
              allLocations={form.allLocations}
              eventDate={form.eventDate}
              saleEndDate={form.saleEndDate}
              eventDescription={form.eventDescription}
              receiptDescription={form.receiptDescription}
              layout2={form.layout2}
              imageFile={form.imageFile}
              imageList={form.imageList}
              ticketDeliveryMethodApp={form.ticketDeliveryMethodApp}
              ticketDeliveryMethodWeb={form.ticketDeliveryMethodWeb}
              refundTerms={form.refundTerms}
              contactEmail={form.contactEmail}
              groupTerms={form.groupTerms}
              stripeAddress={form.stripeAddress}
              processingFee={form.processingFee}
              processingFeeTypes={form.processingFeeTypes}
              ticketTypes={form.ticketTypes}
              showForMembers={form.showForMembers}
              showForFans={form.showForFans}
              showOnWeb={form.showOnWeb}
              currentGroup={form.currentGroup}
              routerParamsGroup={props.router.params.group}
              handleOptionChange={form.handleOptionChange}
              handleInputChange={form.handleInputChange}
              handleDateChange={form.handleDateChange}
              handleImageChange={form.handleImageChange}
              uploadAction={form.uploadAction}
              checkChange={form.checkChange}
              setLocation={form.setLocation}
            />

            <TicketItemsSection
              type={form.type}
              ticketsToRender={form.ticketsToRender}
              tickets={form.tickets}
              soldTickets={form.soldTickets}
              ticketTypes={form.ticketTypes}
              ticketLimit={form.ticketLimit}
              quantity={form.quantity}
              price={form.price}
              limit={form.limit}
              passLimit={form.passLimit}
              handleInputChange={form.handleInputChange}
              handleOptionChange={form.handleOptionChange}
              handleTicketDetailInputChange={form.handleTicketDetailInputChange}
              handleTicketDetailOptionChange={
                form.handleTicketDetailOptionChange
              }
              handleTicketDetailDelete={form.handleTicketDetailDelete}
              addTicket={form.addTicket}
            />

            <SubmitSection
              acceptedTerms={form.acceptedTerms}
              notifyOnPublish={form.notifyOnPublish}
              verifiedChange={form.verifiedChange}
              checkChange={form.checkChange}
              handleSubmit={form.handleSubmit}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default withRouter(CreateTicket);
